import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import { excludeHiddenAnswers } from '../../machine/helpers/logic';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class MatrixRatingApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor, params } = actor.getSnapshot().context;
        const { comment } = responseActor.getSnapshot().context;

        return {
            question: id,
            data: excludeHiddenAnswers(answersActors).map((answerActor) => {
                const { id: answerId, response } = answerActor.getSnapshot().context;
                const { value } = response.getSnapshot().context;
                let numOfStars = Number(value);

                if (params.matrixType === 'stars' && params.minAmount === 0) {
                    numOfStars -= 1;
                }

                if (numOfStars === CANTRATE_ID) {
                    return {
                        answer: answerId,
                        cantRate: true,
                        bool: true,
                    };
                }

                return {
                    answer: answerId,
                    int: numOfStars,
                    bool: true,
                };
            }),
            comment,
        };
    }

    public validate({ answersActors: answersActorsRaw, params: { required } }: QuestionContext): boolean {
        if (required) {
            const answersActors = excludeHiddenAnswers(answersActorsRaw);
            answersActors.forEach((answerActor) => {
                answerActor.send({
                    type: 'SET_VALID',
                    value: typeof answerActor.getSnapshot().context.response.getSnapshot().context.value === 'number',
                });
            });

            return answersActors.every(
                (answerActor) =>
                    typeof answerActor.getSnapshot().context.response.getSnapshot().context.value === 'number',
            );
        }

        return true;
    }
}
